import React, {createContext, useEffect, useState} from "react";

import {Auth} from "@digatex/digatex-ui-lib";

class CurrentUser {
	constructor(tokenData = {}) {
		this.data = tokenData;
	}

	name() {
		return this.data.name || this.data.given_name || "";
	}

	email() {
		return this.data.email || "";
	}

	username() {
		return this.data.preferred_username || "";
	}
}

export const CurrentUserContext = createContext(new CurrentUser());

export const CurrentUserProvider = ({children}) => {
	const [user, setUser] = useState(new CurrentUser());

	useEffect(() => {
		if (Auth.isAuthenticated()) {
			const token = Auth.tokenParsed();
			if (token) {
				setUser(new CurrentUser(token));
			}
		}
	}, []);

	return <CurrentUserContext.Provider value={user}>{children}</CurrentUserContext.Provider>;
};
